<template>
  <div class="con">
    <div class="title">
      <h2>결제</h2>
      <p><br /></p>
    </div>
    <progress-bar></progress-bar>
    <div class="mt-50">
      <div class="apply-fieldset">
        <div class="apply-program-wrap">
          <div class="apply-select-number">
            선택한 클래스
            <span v-if="sessionData.classList" class="txt-red"
              >({{ subjectLength }})</span
            >
            <button class="pointer" @click="moveSelectPage()">
              다시 선택하기
            </button>
          </div>
          <div class="apply-program-select">
            <ul>
              <div v-for="(classItem, idx) of sessionData.classList" :key="idx">
                <!-- 선택 했을 경우 -->
                <li
                  class="program-select blue"
                  v-for="(item, index) of classItem.subjectList"
                  :key="index"
                >
                  <div class="apply-program-unit">
                    <ul>
                      <!-- 선택한 컬러로 클래스 노출, class="blue" -->
                      <li
                        class="unit-title blue"
                        data-toggle="modal"
                        data-target="#program-info"
                      >
                        <h4 class="pay-title" @click="openModal(item)">
                          {{ item.subjectName }}
                        </h4>
                        <img
                          src="../../assets/img/close.png"
                          class="pointer"
                          alt=""
                          @click="deleteClass(index)"
                        />
                      </li>
                      <li>
                        <p
                          v-for="(item, index) of viewItemList(item)"
                          :key="index"
                        >
                          <span
                            >{{ item.key || "-" }}
                            <b class="bold">{{ item.value || "-" }}</b></span
                          >
                        </p>
                      </li>
                    </ul>
                  </div>
                </li>
              </div>
            </ul>
          </div>
        </div>
        <div class="hq-table-row">
          <h3>신청자 정보</h3>
          <table>
            <colgroup>
              <col width="30%" />
              <col width="70%" />
            </colgroup>
            <tbody>
              <tr v-for="(item, index) of info" :key="index">
                <th>{{ item.item_name }}</th>
                <td>{{ item.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="hq-table-row">
          <h3>결제 정보</h3>
          <table>
            <colgroup>
              <col width="30%" />
              <col width="70%" />
            </colgroup>
            <tbody>
              <tr>
                <th>결제금액</th>
                <td>{{ totalPayment }}원</td>
              </tr>
              <tr>
                <th>결제방법</th>
                <td>
                  <label for="card" v-show="payWay.pay_way === 'C'">
                    <input
                      type="radio"
                      v-model="payType"
                      name="payTypeC"
                      id=""
                      value="card"
                    />
                    <span class="txt-13px ml-05 mr-20">카드결제</span>
                  </label>
                  <label for="pay" v-show="payWay.pay_way === 'A'">
                    <input
                      type="radio"
                      v-model="payType"
                      name="payTypeA"
                      id=""
                      value="trans"
                    />
                    <span class="txt-13px ml-05 mr-20">실시간 계좌이체</span>
                  </label>
                  <label for="pay" v-show="payWay.pay_way === 'D'">
                    <input
                      type="radio"
                      v-model="payType"
                      name="payTypeD"
                      id=""
                      value="card"
                    />
                    <span class="txt-13px ml-05 mr-20">카드결제</span>
                    <input
                      type="radio"
                      v-model="payType"
                      name="payTypeD"
                      id=""
                      value="trans"
                    />
                    <span class="txt-13px ml-05 mr-20">실시간 계좌이체</span>
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="apply-agree-btn">
      <button
        type="button"
        :class="setButtonColor()"
        @click="applyByTossPayments()"
      >
        {{ isFinishPage ? "수강신청 하기" : "다음" }}
      </button>
    </div>
    <detail-process
      v-if="isDetailModalOpened"
      :parentData="parentData"
      @close="closeModal()"
    ></detail-process>
  </div>
</template>

<script>
import Vue from "vue";
import DetailProcess from "@/components/reg/select/detailModal.vue";
import { RouterLink } from "vue-router";
import { TOSS_PAYMENT_CLIENT_KEY } from "@/utils/constants";

const EventBus = new Vue();
const IMPCODE_APPLY = "imp28895051"; // Carrotglobal Iamport 실제 IMP코드

const PGCODE_F = "kicc.IM000066"; // 글로벌 면세
const PGCODE_T = "kicc.IM000065"; // 글로벌 과세

const solutions_PGCODE_F = "kicc.IM000106"; // 솔루션 면세
const solutions_PGCODE_T = "kicc.IM000105"; // 솔루션 과세

const PGCODE_F_TEST = "kicc.T5102001"; // 글로벌 면세
const PGCODE_T_TEST = "kicc.T5102001"; // 글로벌 과세

const solutions_PGCODE_F_TEST = "kicc.T5102001"; // 솔루션 면세
const solutions_PGCODE_T_TEST = "kicc.T5102001"; // 솔루션 과세

export default {
  components: {
    DetailProcess,
  },
  data: () => ({
    sessionData: {}, // 세션 스토리지 수강신청 등록 전체 데이터
    info: [], // 전 페이지에서 사용자 정보 입력된 데이터
    payWay: {}, // 지불 방법
    totalPayment: 0, // 결제 최종 금액
    payType: "card", // card: 카드결제, trans: 실시간 계좌이체

    merchantUid: "", // api 결제 승인났을때 고유 아이디 받음 (이 아이디로 iamport에 사용)
    orderId: "", // 주문 id
    impUid: "", // imp id
    isDetailModalOpened: false, // 클래스 상세보기 레이어팝업 on/off
    parentData: {}, // 레이어팝업에 전달할 해당 강의 데이터
    mainIdx: "",

    payWayP: "C", // 지불 방법
    partialPay: "A", // 전체결제 A 부분결제 P
    taxType: "T", // 과세 T, 면세 F
    pgCodeType: "inicis",
    isFinishPage: false, // 현재 페이지가 마지막 페이지인지
    subjectLength: 0,
    pageIdx: "",

    pointColor: "blue",

    payment: null, // 토스 페이먼트 인스턴스
    isLoading: false, // 결제 로딩 상태
  }),

  watch: {
    // 등록 페이지 내의 현재 라우터 경로 감지
    // Watch에 넣어놓은 이유는 keep-alive 사용으로 페이지 진입후 재진입할때 mount가 안되기 때문
    $route(to) {
      if (this.$route.fullPath === "/user/reg/payment") {
        this.loadSugangData();
      }
    },
  },

  mounted() {
    this.pointColor = sessionStorage.getItem("pointColor");

    this.loadSugangData();
    //TODO: idx 추후에 변경해야함
    var idx = sessionStorage.getItem("mainIdx");
    this.mainIdx = sessionStorage.getItem("mainIdx");
    var params = {
      idx: idx,
    };
    this.axios
      .get(this.axios.root + this.axios.port + `/sugang/pay-way/${idx}`)
      .then((res) => {
        // console.log('res', res)
        if (res.data.err === 0) {
          this.payWay = res.data.payWay;
          this.taxType = res.data.payWay.tax_type;

          if (this.payWay.pay_way === "C") {
            this.payType = "card";
            this.payWayP = "C";
          } else if (this.payWay.pay_way === "A") {
            this.payType = "trans";
            this.payWayP = "A";
          }

          if (res.data.payWay.partial_pay) {
            this.partialPay = res.data.payWay.partial_pay;
          }
        } else {
          alert(res.data.result);
        }
      });

    var pathArray = this.$route.fullPath.split("/");
    var length = pathArray.length;
    var pageType = pathArray[length - 1];
    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
    var finishPage = pOrder[pOrder.length - 1];

    if (pageType === finishPage) {
      this.isFinishPage = true;
    }

    // 토스 페이
    const script = document.createElement("script");
    script.src = "https://js.tosspayments.com/v2/standard";
    script.onload = this.initializePayment;
    document.head.appendChild(script);
  },

  methods: {
    // 토스 페이먼트 초기화
    initializePayment() {
      const isTest =
        location.href.includes("local") || location.href.includes("stage");

      const clientKey = isTest
        ? TOSS_PAYMENT_CLIENT_KEY.TEST
        : TOSS_PAYMENT_CLIENT_KEY.LIVE;

      const tossPayments = window.TossPayments(clientKey);
      const customerKey = "cust_" + Math.random().toString(36).slice(2);

      this.payment = tossPayments.payment({ customerKey });
    },

    // 토스 페이먼트 클릭 이벤트 추적
    trackClickPayment() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "click_payment",
        product_id: this.sessionData.classList[0].classIdx,
        product_name: this.sessionData.classList[0].className,
        price: this.totalPayment,
      });
    },

    // 수강신청 하기
    async applyByTossPayments() {
      console.log("applyByTossPayments");
      const self = this;

      if (self.sessionData.classList[0].subjectList.length === 0) {
        alert("선택한 클래스가 1개 이상 있어야 합니다.");
        return false;
      }

      if (self.payType === "card") {
        self.payWayP = "C";
      } else if (self.payType === "trans") {
        self.payWayP = "A";
      }

      var params = [];
      for (var item of self.sessionData.classList) {
        for (var subject of item.subjectList) {
          var tempQuery = {
            bookPriceYN: "Y",
            idxItmSugangPageMain: self.pageIdx,
            idxItmSugangSubject: subject.subjectIdx,
            name: self.name,
            email: self.email,
            payWay: self.payWayP,
            partialPay: self.partialPay,
            status: "N",
            price: subject.eduPrice + subject.bookPrice,
            subjectName: subject.subjectName,
            totalPrice: self.totalPayment,
          };

          if (subject.eduPrice === 0 && subject.bookPrice !== 0) {
            tempQuery["partialPay"] = "B";
          } else if (subject.eduPrice !== 0 && subject.bookPrice === 0) {
            tempQuery["partialPay"] = "C";
          } else {
            tempQuery["partialPay"] = "A";
          }
          params.push(tempQuery);
        }
      }

      if (params[0].name == "") {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }

      if (params[0].email == "") {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }

      if (params[0].name == null) {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }

      if (params[0].email == null) {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }

      if (typeof params[0].name == "undefined") {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }

      if (typeof params[0].name == "undefined") {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }

      // 모바일 데이터 localstorage에 저장
      self.storeMobilePayData();
      self.axios
        .post(self.axios.root + self.axios.port + "/pay/check", params)
        .then(async (res) => {
          if (res.data.err === 0) {
            if (this.isLoading) {
              return;
            }

            if (!this.payment) {
              alert("결제 모듈이 초기화되지 않았습니다.");
              return;
            }

            this.trackClickPayment();

            sessionStorage.setItem(
              "paymentUserInfo",
              JSON.stringify(this.info)
            );

            self.merchantUid = res.data.merchantUid;

            const isProduction =
              window.location.host === "apply.carrotglobal.com" ||
              window.location.host === "apply2.carrotglobal.com";
            const noticeUrl = isProduction
              ? "https://apply-api.carrotglobal.com/external/sugang/new/webhook"
              : "https://stage-itmsugang-api.carrotenglish.net/external/sugang/new/webhook";

            self.saveChkTmp(
              res.data.merchantUid,
              "",
              res.data.merchantUid,
              self.totalPayment,
              "/pay/checkTmp"
            );

            // 토스 결제 시작
            this.trackClickPayment();
            this.isLoading = true;

            sessionStorage.setItem(
              "paymentUserInfo",
              JSON.stringify(this.info)
            );

            try {
              const isTaxFree = self.taxType === "F";
              const payload = {
                method: "CARD",
                amount: {
                  currency: "KRW",
                  value: self.totalPayment,
                },
                orderId: this.sessionData.merchantUid,
                orderName: self.sessionData.classList[0].className,
                successUrl: `${window.location.origin}/paymentRedirect`,
                failUrl: `${window.location.origin}/payment`,
                customerName: this.sessionData.name,
                customerEmail: this.sessionData.email,
                card: { useEscrow: false },
                taxFreeAmount: self.totalPayment,
              };

              if (isTaxFree) {
                payload.taxFreeAmount = self.totalPayment;
              } else {
                payload.amount = {
                  currency: "KRW",
                  value: self.totalPayment,
                };
              }

              await this.payment.requestPayment(payload);
            } catch (e) {
              sessionStorage.removeItem("paymentUserInfo");
              alert(e.message || "결제 요청에 실패했습니다.");
              this.isLoading = false;
            }
          } else {
            alert(res.data.result);
          }
        })
        .catch((err) => {
          alert(err);
        });
    },

    async requestPayment() {
      if (this.isLoading) {
        return;
      }

      if (!this.payment) {
        alert("결제 모듈이 초기화되지 않았습니다.");
        return;
      }

      this.trackClickPayment();
      this.isLoading = true;

      sessionStorage.setItem("paymentUserInfo", JSON.stringify(this.info));

      try {
        await this.payment.requestPayment({
          method: "CARD",
          amount: {
            currency: "KRW",
            value: this.totalPayment,
          },
          orderId: this.orderId,
          orderName: this.sessionData.classList[0].subjectList[0].subjectName,

          successUrl: `${window.location.origin}/paymentOk`,
          failUrl: `${window.location.origin}/payment`,

          customerName: this.info[0].value,
          customerEmail: this.info[1].value,

          customerMobilePhone: this.info[2].value.replace(/[^\d]/g, ""),

          card: {
            useEscrow: false,
          },

          taxFreeAmount: this.totalPayment,
        });
      } catch (e) {
        sessionStorage.removeItem("paymentUserInfo");
        alert(e.message || "결제 요청에 실패했습니다.");
        this.isLoading = false;
      }
    },

    setButtonColor() {
      if (this.pointColor === "Blue") {
        return "blue";
      } else if (this.pointColor === "Red") {
        return "red";
      } else if (this.pointColor === "Green") {
        return "green";
      }
    },

    // 선택한 클래스 삭제
    deleteClass(idx) {
      this.totalPayment -=
        this.sessionData.classList[0].subjectList[idx].eduPrice +
        this.sessionData.classList[0].subjectList[idx].bookPrice;
      this.sessionData.classList[0].subjectList.splice(idx, 1);
    },

    // 클래스선택 페이지로 이동
    moveSelectPage() {
      this.$router.push("/user/reg/select");
    },

    // 세션 스토리지 수강신청 전체 데이터 loading
    loadSugangData() {
      this.sessionData = JSON.parse(sessionStorage.getItem("classData"));
      this.pageIdx = sessionStorage.getItem("pageIdx");
      this.info = this.sessionData.info;
      this.totalPayment = this.sessionData.totalPayment;

      var count = 0;
      if (this.sessionData.classList) {
        for (var item of this.sessionData.classList) {
          for (var subject of item.subjectList) {
            count += 1;
          }
        }
      }

      this.subjectLength = count;

      for (var item of this.info) {
        if (item.item_name === "이름") {
          this.name = item.value;
        } else if (item.item_name.includes("E-mail@")) {
          this.email = item.value;
        }
      }
    },

    // 숫자 1000 단위로 콤마찍기 (1000 => 1,000)
    numberFormat(inputNumber) {
      if (inputNumber) {
        return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "-";
      }
    },

    storeMobilePayData() {
      if (this.sessionData) {
        var mobilePayData = JSON.parse(JSON.stringify(this.sessionData));
        mobilePayData["idxItmSugangPageMain"] =
          sessionStorage.getItem("pageIdx");
        mobilePayData["partialPay"] = this.partialPay;
        mobilePayData["payStatus"] = "Y";
        if (mobilePayData["mobile"]) {
          mobilePayData["mobile"] = mobilePayData["mobile"];
        } else {
          mobilePayData["mobile"] = "";
        }
        mobilePayData["payWay"] = this.payWayP;
        mobilePayData["type"] = "Y";
        mobilePayData["programIdx"] = sessionStorage.getItem("programIdx");

        mobilePayData["studentSubjectIdx"] = -1;

        var itemNames = [
          "이름",
          "비밀번호",
          "사번",
          "휴대전화번호",
          "직급",
          "부서",
          "회사",
          "공인시험점수",
        ];
        var count = 1;

        if (mobilePayData["info"]) {
          for (var item of mobilePayData["info"]) {
            if (item.item_name.includes("E-mail@")) {
              continue;
            } else if (itemNames.includes(item.item_name)) {
              continue;
            } else {
              mobilePayData["optionName" + count.toString()] = item.item_name;
              mobilePayData["optionContents" + count.toString()] = item.value;
              count += 1;
            }
          }
        }

        delete mobilePayData["totalPayment"];

        localStorage.setItem("mobilePayData", JSON.stringify(mobilePayData));
      }
    },
    saveChkTmp(orderId, impUid, merchantUid, amount, url) {
      var infoData = JSON.parse(JSON.stringify(this.sessionData["info"]));

      this.sessionData = {
        ...this.sessionData,
        info: infoData,
        idxItmSugangPageMain: sessionStorage.getItem("pageIdx"),
        partialPay: this.partialPay,
        payStatus: "Y",
        mobile: this.sessionData.mobile ? this.sessionData.mobile : "",
        payWay: this.payWayP,
        amount: amount,
        merchantUid: merchantUid,
        impUid: impUid,
        orderId: orderId,
        type: "Y",
        programIdx: sessionStorage.getItem("programIdx"),
        studentSubjectIdx: -1,
      };

      var itemNames = [
        "이름",
        "비밀번호",
        "사번",
        "휴대전화번호",
        "직급",
        "부서",
        "회사",
        "공인시험점수",
      ];
      var count = 1;

      if (this.sessionData["info"]) {
        for (var item of this.sessionData["info"]) {
          if (item.item_name.includes("E-mail@")) {
            continue;
          } else if (itemNames.includes(item.item_name)) {
            continue;
          } else {
            this.sessionData["optionName" + count.toString()] = item.item_name;
            this.sessionData["optionContents" + count.toString()] = item.value;
            count += 1;
          }
        }
      }

      let params = this.sessionData;

      this.axios
        .post(this.axios.root + this.axios.port + url, params)
        .then(async (res) => {
          if (Number(res.data.err) === 0) {
          } else {
            return false;
          }
        })
        .catch(async (err) => {
          console.error(url + "error : ", err);
          alert("데이터 저장에 실패했습니다.");
        });
    },

    viewItemList(data) {
      if (data.columnOrder) {
        var itemList = data.columnOrder.split("^");
        var returnItemList = [];
        for (var item of itemList) {
          if (item === "언어") {
            returnItemList.push({
              key: item,
              value: data.language,
            });
          } else if (item === "장소") {
            returnItemList.push({
              key: item,
              value: data.place,
            });
          } else if (item === "요일") {
            if (data.day && typeof data.day === "string") {
              returnItemList.push({
                key: item,
                value: data.day.replace(/\^/gi, ""),
              });
            }
          } else if (item === "교육시간") {
            returnItemList.push({
              key: item,
              value: data.subjectStartTime + "~" + data.subjectEndTime,
            });
          } else if (item === "교육비") {
            returnItemList.push({
              key: item,
              value: data.eduPrice,
            });
          } else if (item === "교재비") {
            returnItemList.push({
              key: item,
              value: data.bookPrice,
            });
          }
        }

        return returnItemList;
      } else {
        return [];
      }
    },

    // 클래스 상세보기 레이어팝업 열기
    openModal(data) {
      this.parentData = data;
      this.isDetailModalOpened = true;
    },

    // 모달 닫기
    closeModal() {
      this.isDetailModalOpened = false;
    },
  },
};
</script>
